export const PROJECT_TAGS = {
  PROJECTS: "Projects",
  PROJECT_PROPOSALS: "ProjectProposals",
  PROJECT_ACTIONS: "ProjectActions",
  PRE_SALES_KPIS: "PreSalesKpis",
} as const;
